import { isEmpty } from 'lodash';

import translatePipelineIntegrations from 'app/shared/translation/integrations/translatePipelineIntegrations';

/**
 * Builds the pipeline JSON POSTed to a cluster on deploy.
 *
 * @param {Object} args
 * @param {Array} args.pipelineIntegrations - Pipeline integrations with staged revisions.
 * @param {Array} [args.cliManagedIntegrations] - Deployed integration JSON for CLI-managed
 *   integrations, appended verbatim.
 * @param {string} args.author
 * @param {string} args.writeKey
 * @param {Object} [args.pipelineConfiguration] - Resolved pipeline-level configuration
 *   (see resolvePipelineConfiguration): supported, non-nil fields only. Spread verbatim
 *   into the deploy JSON — an unresolved pipeline object would leak its keys to the cluster.
 * @returns {Object} The deploy body's pipeline JSON.
 */
export default function buildPipelineJson({
  pipelineIntegrations,
  cliManagedIntegrations,
  author,
  writeKey,
  pipelineConfiguration,
}) {
  const stagedPipelineIntegrations = pipelineIntegrations.filter(
    pipelineIntegration => !pipelineIntegration.stagedRevision.stagedForDelete
  );

  const integrations = translatePipelineIntegrations({
    pipelineIntegrations: stagedPipelineIntegrations,
  });

  if (!isEmpty(cliManagedIntegrations)) {
    integrations.push(...cliManagedIntegrations);
  }

  const result = {
    writeKey,
    integrations,
    author,
    ...pipelineConfiguration,
  };

  return result;
}
